import React, { useEffect, useRef } from 'react';
import './Modal.scss';

export const Modal = (props: IModalProps) => {
  const modalRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (modalRef.current) {
      const options = {};
      props.onLoad(window.M.Modal.init(modalRef.current, options));
    }
  }, [modalRef.current]);

  const title = !props.title ? null : (
    <div className="modal-label p-3">{props.title}</div>
  );

  return (
    <>
      <div
        className={`modal ${
          props.confimationModal ? 'confirmation-modal' : ''
        }`}
        ref={modalRef}
        id={'modal'}
      >
        {title}
        <div className="modal-content p-2">{props.children}</div>
      </div>
    </>
  );
};
